import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";
import { FoundationsState } from "./types";

const baseSelector = createSelector(
    (state: RootState) => state,
    state => state.foundations
)

export const selectFoundations = createSelector(
    baseSelector,
    (state: FoundationsState) => state.foundations
)

export const selectFoundationsLoading = createSelector(
    baseSelector,
    (state: FoundationsState) => state.isFoundationsLoading
)

export const selectFoundationsFirstLoad = createSelector(
    baseSelector,
    (state: FoundationsState) => state.isFoundationsFirstLoad
)

export const selectFoundationsError = createSelector(
    baseSelector,
    (state: FoundationsState) => state.foundationsError
)